import { TermsConditions } from '~/components/pages/pages-async.js';
import { informationPagesClasses } from './constants.js';
import { HeadWrapper, MainTitle, SubTitle } from '~/components/misc/section-head.js';
import Icon, { ICON_DOCUMENT_SEARCH_LINE } from '~/components/icon/index.js';
import useTranslations from '~/components/translation/use-translations.ts';

const textKeys = ['MOBILE_HELP_PAGE_SUBMENU_TERMS', 'MOBILE_TERMS_CONDITIONS_SUPPORT_TITLE'];

// FIXME : we need to remove this prop spreading
const TermsAndConditions = props => {
	const { translations: tr, isLoadingTranslations } = useTranslations(textKeys);

	if (isLoadingTranslations) {
		return <div className="spinner" />;
	}

	return (
		<TermsConditions
			wrapperClasses={informationPagesClasses}
			hideBackButton={props.hideBackButton}
			HeaderWrapper={
				<HeadWrapper>
					<Icon type={ICON_DOCUMENT_SEARCH_LINE} className="content-wrapper__icon" />
					<MainTitle dataAt="section-main-title-general-global-overlay">
						{tr.MOBILE_HELP_PAGE_SUBMENU_TERMS}
					</MainTitle>
					<SubTitle dataAt="section-sub-title-header-general-global-overlay">
						{tr.MOBILE_TERMS_CONDITIONS_SUPPORT_TITLE}
					</SubTitle>
				</HeadWrapper>
			}
			{...props}
		/>
	);
};

export default TermsAndConditions;
